/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button } from '@radix-ui/themes';

import { use, useCallback } from 'fierry/react';

import Auth, { OFFLINE } from 'solis/auth';


const OnSignOut = (event, auth) =>
{
  auth.signOut();
};


export default () =>
{
  const auth = use(Auth);

  const onSignOut = useCallback(OnSignOut, [ auth ]);

  if (OFFLINE)
  {
    return null;
  }

  return <Button variant = 'soft' color = 'gray' onClick = {onSignOut}>Sign out</Button>;
};
